const { swapObject } = require('../utils')

const EXT_TO_MIME = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  wav: 'audio/wav',
  mp3: 'audio/mp3',
  jpg: 'image/jpg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  mp4: 'video/mp4',
  ogg: 'audio/ogg'
}
exports.EXT_TO_MIME = EXT_TO_MIME

const EXCEPTIONS = {
  xls: EXT_TO_MIME.csv,
  xlsx: EXT_TO_MIME.csv,
  doc: EXT_TO_MIME.docx,
  jpg: EXT_TO_MIME.jpeg,
  png: EXT_TO_MIME.jpeg,
  gif: EXT_TO_MIME.jpeg,
  mp3: EXT_TO_MIME.wav
}
exports.EXCEPTIONS = EXCEPTIONS

const EXT_TO_MIME_SHORT = Object.assign({}, EXT_TO_MIME, EXCEPTIONS)
exports.EXT_TO_MIME_SHORT = EXT_TO_MIME_SHORT

const MIME_TO_EXT = swapObject(EXT_TO_MIME)
MIME_TO_EXT['audio/mpeg'] = 'mp3'
MIME_TO_EXT['audio/ogg; codecs=opus'] = 'ogg'
exports.MIME_TO_EXT = MIME_TO_EXT
exports.MIME_TO_EXT_SHORT = swapObject(Object.keys(EXT_TO_MIME).reduce((result, key) => {
  if (!EXCEPTIONS[key]) {
    result[key] = EXT_TO_MIME[key]
  }

  return result
}, {}))
